import Vue from 'vue'
import App from './App.vue'
import router from './router'
import { store } from './store'
import axios from 'axios'
import Vuelidate from 'vuelidate'
// adding bootstrap framework to the app
import BootstrapVue from 'bootstrap-vue'
import 'bootstrap/dist/css/bootstrap.css'
import 'bootstrap-vue/dist/bootstrap-vue.css'
import './assets/css/normalize.css'
import './assets/css/main.css'
import './assets/css/utilities/extra-styles-bootstrap.css'
// adding fontawesome library to the app
import { library } from '@fortawesome/fontawesome-svg-core'
import {
  faHome,
  faQuestion,
  faQuestionCircle,
  faCommentAlt,
  faEnvelope,
  faEnvelopeSquare,
  faEnvelopeOpenText,
  faPlus,
  faUserCog,
  faChevronRight,
  faChevronCircleLeft,
  faChevronCircleRight,
  faCaretLeft,
  faTachometerAlt,
  faBullhorn,
  faNewspaper,
  faPeopleCarry,
  faUserSecret,
  faHandHoldingUsd,
  faUsers,
  faUndo,
  faPercentage,
  faHouseUser,
  faTh,
  faShoppingCart,
  faClipboardList,
  faVolumeUp,
  faPersonBooth,
  faGavel,
  faBars,
  faTruck,
  faTruckLoading,
  faTruckMoving,
  faTruckMonster,
  faTruckPickup,
  faPeopleArrows,
  faTimes,
  faBan,
  faSpinner,
  faBox,
  faBoxOpen,
  faExchangeAlt,
  faCheck,
  faFileSignature,
  faSearch,
  faSort,
  faPen,
  faEye,
  faTrash,
  faTrashAlt,
  faFutbol,
  faStreetView,
  faRunning,
  faChild,
  faUsersCog,
  faCalendarAlt,
  faPoll,
  faTrophy,
  faGlobe,
  faRegistered,
  faFile,
  faFileAlt,
  faPowerOff,
} from '@fortawesome/free-solid-svg-icons'
import { faQuestionCircle as faQuestionCircleReg} from '@fortawesome/free-regular-svg-icons'
import { faYoutube, faFacebook, faFacebookSquare, faFacebookMessenger, faFacebookF } from '@fortawesome/free-brands-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'

library.add(
  faYoutube,
  faFacebook,
  faFacebookSquare,
  faFacebookMessenger,
  faFacebookF,
  faHome,
  faQuestion,
  faQuestionCircle,
  faQuestionCircleReg,
  faCommentAlt,
  faEnvelope,
  faEnvelopeSquare,
  faEnvelopeOpenText,
  faPlus,
  faUserCog,
  faChevronRight,
  faChevronCircleLeft,
  faChevronCircleRight,
  faCaretLeft,
  faTachometerAlt,
  faBullhorn,
  faNewspaper,
  faPeopleCarry,
  faUserSecret,
  faHandHoldingUsd,
  faUsers,
  faUndo,
  faPercentage,
  faHouseUser,
  faTh,
  faShoppingCart,
  faClipboardList,
  faPersonBooth,
  faVolumeUp,
  faGavel,
  faBars,
  faTruck,
  faTruckLoading,
  faTruckMoving,
  faTruckMonster,
  faTruckPickup,
  faPeopleArrows,
  faTimes,
  faBan,
  faSpinner,
  faBox,
  faBoxOpen,
  faExchangeAlt,
  faCheck,
  faFileSignature,
  faSearch,
  faSort,
  faPen,
  faEye,
  faTrash,
  faTrashAlt,
  faFutbol,
  faStreetView,
  faRunning,
  faChild,
  faUsersCog,
  faCalendarAlt,
  faPoll,
  faTrophy,
  faGlobe,
  faRegistered,
  faFile,
  faFileAlt,
  faPowerOff,
);

Vue.component('font-awesome-icon', FontAwesomeIcon);

Vue.use(BootstrapVue);
Vue.use(Vuelidate);

Vue.config.productionTip = false;

// Defining some axios constant parameters that won't change in any request
// axios.defaults.baseURL = store.getters.getBaseURL + 'crud/';
axios.defaults.headers.common = {
  // 'Access-Control-Allow-Origin': '*',
  'Content-Type': 'application/json'
};

new Vue({
  el: '#app',
  store,
  router,
  components: { App },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js